/**
 * PUCCI × XGEN — Shared Helpers
 * ──────────────────────────────
 * Funzioni condivise tra Search e Recommendations.
 */

(function () {
  'use strict';

  const PRICE_GROUPING_COUNTRIES = ['jp'];

  // ─── FACET TRANSLATION MAP ───────────────────────────────────────────────────
  const FACET_TRANSLATION_MAP = {
    en: {
      category: {
        "athleisure": "Athleisure", "babygrow": "Babygrown", "bag accessories": "Bag accessories",
        "bags": "Bags", "ballerina shoes": "Ballerina Shoes", "beach towels": "Beach towels",
        "beachwear": "Beachwear", "beauty": "Beauty", "beanbags": "Beanbags", "belts": "Belts",
        "bikini": "Bikini", "blankets": "Blankets", "blazers": "Blazers", "blouse": "Blouse",
        "bodysuits": "Bodysuits", "boots": "Boots", "bottle": "Bottle", "bracelets": "Bracelets",
        "cape": "Cape", "coats": "Coats", "combs": "Combs", "cosmetic case": "Cosmetic Case",
        "cosmetic Case": "Cosmetic Case", "dresses": "Dresses", "earrings": "Earrings",
        "games": "Games", "gloves": "Gloves", "hair accessories": "Hair accessories",
        "hats": "Hats", "headband": "Headbands", "jackets": "Jackets", "jewellery": "Jewellery",
        "jumpsuits": "Jumpsuits", "kaftans": "Kaftans", "keychains": "Keychains",
        "knitwear": "Knitwear", "leggings": "Leggings", "lifestyle": "Lifestyle", "lilo": "Lilo",
        "make up": "Make up", "maternity set": "Maternity Set", "necklaces": "Necklaces",
        "pants": "Pants", "puffers": "Puffers", "sandals": "Sandals", "sarongs": "Sarongs",
        "scarves": "Scarves", "shirts and blouses": "Shirts and Blouses", "shirts": "Shirts",
        "shoes": "Shoes", "shorts": "Shorts", "shoulder strap": "Shoulder Strap",
        "shoulder Strap": "Shoulder Strap", "skirts": "Skirts",
        "small leather goods": "Small leather goods", "snowsuit": "Snowsuit",
        "socks and tights": "Socks and Tights", "stoles": "Stoles", "sunglasses": "Sunglasses",
        "sweaters": "Sweaters", "sweatshirts": "Sweatshirts", "swimsuits": "Swimsuits",
        "swimwear": "Swimwear", "t-shirts": "T-shirts", "ties": "Ties",
        "tops and t-shirts": "Tops and T-Shirts", "tops": "Tops", "trousers": "Trousers",
        "underwear": "Underwear"
      },
      color: {
        "pruple": "Purple", "khaki/nude": "Khaki/Nude", "pink": "Pink", "nude": "Nude",
        "khaki": "Khaki", "toupe": "Taupe", "brown": "Brown", "light blue": "Light blue",
        "lime": "Lime", "grey": "Grey", "white": "White", "emerald": "Emerald",
        "green": "Green", "bronze": "Bronze", "multicolor": "Multicolor", "ivory": "Ivory",
        "gold": "Gold", "yellow": "Yellow", "navy": "Navy", "fuxia": "Fuchsia",
        "fuchsia": "Fuchsia", "red": "Red", "turquoise": "Turquoise", "lilac": "Lilac",
        "taupe": "Taupe", "orange": "Orange", "black": "Black", "silver": "Silver",
        "coral": "Coral", "blue": "Blue", "lightblue": "Light blue", "purple": "Purple"
      },
      gender: {
        "man": "Man", "unisex": "Unisex", "woman": "Woman", "girl": "Girl",
        "junior": "Junior", "boy": "Boy"
      }
    },
    it: {
      category: {
        "athleisure": "Abbigliamento sportivo", "babygrow": "Tutine",
        "bag accessories": "Accessori per borse", "bags": "Borse",
        "ballerina shoes": "Scarpe da ballerina", "beach towels": "Asciugamani da spiaggia",
        "beauty": "Beauty", "beachwear": "Beachwear", "beanbags": "Borse a fagiolo",
        "belts": "Cinture", "bikini": "Bikini", "blankets": "Coperte", "blazers": "Blazer",
        "blouse": "Camicetta", "bodysuits": "Body", "boots": "Stivali", "bottle": "Bottiglia",
        "bracelets": "Braccialetti", "cape": "Mantellina", "coats": "Cappotti",
        "combs": "Pettini", "cosmetic case": "Astuccio per cosmetici",
        "cosmetic Case": "Astuccio per cosmetici", "dresses": "Abiti", "earrings": "Orecchini",
        "games": "Giochi", "gloves": "Guanti", "hair accessories": "Accessori per capelli",
        "hats": "Cappelli", "headband": "Cerchietto", "jackets": "Giacche",
        "jewellery": "Gioielli", "jumpsuits": "Tute", "kaftans": "Caftani",
        "keychains": "Portachiavi", "knitwear": "Maglieria", "leggings": "Leggings",
        "lifestyle": "Lifestyle", "lilo": "Lilo", "make up": "Make up",
        "maternity set": "Set Maternità", "necklaces": "Collane", "pants": "Pantaloni",
        "puffers": "Piumini", "sandals": "Sandali", "sarongs": "Sarongs",
        "scarves": "Foulard", "shirts and blouses": "Camicie e Bluse", "shirts": "Camicie",
        "shoes": "Scarpe", "shorts": "Pantaloncini", "shoulder strap": "Tracolla",
        "shoulder Strap": "Tracolla", "skirts": "Gonne",
        "small leather goods": "Piccola pelletteria", "snowsuit": "Tute da scii",
        "socks and tights": "Calze e Collant", "stoles": "Stole",
        "sunglasses": "Occhiali da sole", "sweaters": "Maglioni", "sweatshirts": "Felpe",
        "swimsuits": "Costumi da bagno", "swimwear": "Costumi da bagno", "t-shirts": "T-shirt",
        "ties": "Cravatte", "tops and t-shirts": "Top e T-shirt", "tops": "Top",
        "trousers": "Pantaloni", "underwear": "Intimo"
      },
      color: {
        "pruple": "Viola", "khaki/nude": "Kaki/Nude", "pink": "Rosa", "nude": "Nude",
        "khaki": "Kaki", "toupe": "Tortora", "brown": "Marrone", "light blue": "Azzurro",
        "lime": "Lime", "grey": "Grigio", "white": "Bianco", "emerald": "Smeraldo",
        "green": "Verde", "bronze": "Bronzo", "multicolor": "Multicolore", "ivory": "Beige",
        "gold": "Oro", "yellow": "Giallo", "navy": "Blu navy", "fuxia": "Fucsia",
        "fuchsia": "Fucsia", "red": "Rosso", "turquoise": "Turchese", "lilac": "Lilla",
        "taupe": "Tortora", "orange": "Arancione", "black": "Nero", "silver": "Argento",
        "coral": "Corallo", "blue": "Blu", "lightblue": "Azzurro", "purple": "Viola"
      },
      gender: {
        "man": "Uomo", "unisex": "Unisex", "woman": "Donna", "girl": "Ragazza",
        "junior": "Junior", "boy": "Ragazzo"
      }
    },
    ja: {
      category: {
        "athleisure": "アスレジャー", "babygrow": "ベビーフェイス",
        "bag accessories": "バッグアクセサリー", "bags": "バッグ",
        "ballerina shoes": "バレリーナシューズ", "beach towels": "ビーチタオル",
        "beachwear": "ビーチウェア", "beanbags": "ビーンバッグ", "belts": "ベルト",
        "bikini": "ビキニ", "blankets": "ブランケット", "blazers": "ブレザー",
        "blouse": "ブラウス", "beauty": "ビューティー", "bodysuits": "ボディスーツ",
        "boots": "ブーツ", "bottle": "ボトル", "bracelets": "ブレスレット",
        "cape": "ケープ", "coats": "コート", "combs": "コーム",
        "cosmetic case": "化粧品ケース", "cosmetic Case": "化粧品ケース",
        "dresses": "ドレス", "earrings": "イヤリング", "games": "ゲーム",
        "gloves": "手袋", "hair accessories": "ヘアアクセサリー", "hats": "帽子",
        "headband": "ヘッドバンド", "jackets": "ジャケット", "jewellery": "ジュエリー",
        "jumpsuits": "ジャンプスーツ", "kaftans": "カフタン", "keychains": "キーホルダー",
        "knitwear": "ニット", "leggings": "レギンス", "lifestyle": "ライフスタイル",
        "lilo": "リロ", "make up": "メイクアップ", "maternity set": "マタニティセット",
        "necklaces": "ネックレス", "pants": "パンツ", "puffers": "パファー",
        "sandals": "サンダル", "sarongs": "サロン", "scarves": "スカーフ",
        "shirts and blouses": "シャツ＆ブラウス", "shirts": "シャツ", "shoes": "シューズ",
        "shorts": "ショートパンツ", "shoulder strap": "ショルダーストラップ",
        "shoulder Strap": "ショルダーストラップ", "skirts": "スカート",
        "small leather goods": "革小物", "snowsuit": "スノースーツ",
        "socks and tights": "ソックス＆タイツ", "stoles": "ストール",
        "sunglasses": "サングラス", "sweaters": "セーター", "sweatshirts": "スウェット",
        "swimsuits": "水着", "swimwear": "水着", "t-shirts": "Tシャツ", "ties": "ネクタイ",
        "tops and t-shirts": "トップス&Tシャツ", "tops": "トップス",
        "trousers": "パンツ", "underwear": "アンダーウェア"
      },
      color: {
        "pruple": "パープル", "khaki/nude": "カーキ/ヌード", "pink": "ピンク",
        "nude": "ヌード", "khaki": "カーキ", "toupe": "トープ", "brown": "ブラウン",
        "light blue": "ライトブルー", "lime": "ライム", "grey": "グレー",
        "white": "ホワイト", "emerald": "エメラルド", "green": "グリーン",
        "bronze": "ブロンズ", "multicolor": "マルチカラー", "ivory": "アイボリー",
        "gold": "ゴールド", "yellow": "イエロー", "navy": "ネイビー",
        "fuxia": "フクシア", "fuchsia": "フクシア", "red": "レッド",
        "turquoise": "ターコイズ", "lilac": "ライラック", "taupe": "トープ",
        "orange": "オレンジ", "black": "ブラック", "silver": "シルバー",
        "coral": "コーラル", "blue": "ブルー", "lightblue": "ライトブルー",
        "purple": "パープル"
      },
      gender: {
        "man": "男性", "unisex": "ユニセックス", "woman": "女性", "girl": "女の子",
        "junior": "ジュニア", "boy": "男の子"
      }
    }
  };

  const FACET_KEY_TO_TYPE = {
    gender: 'gender',
    custom_string_1: 'gender',
    category: 'category',
    custom_string_2: 'category',
    color: 'color',
    custom_array_2: 'color',
    custom_array_5: 'color',
  };

  // ─── SHOPIFY CONTEXT ────────────────────────────────────────────────────────
  function getShopifyCountry() {
    return window.Shopify?.country?.toLowerCase() || '';
  }

  function getShopifyLocale() {
    return (window.Shopify?.locale?.split('-')[0] || 'it').toLowerCase();
  }

  function getShopifyCurrency() {
    return window.Shopify?.currency?.active || 'EUR';
  }

  function needsLocalization() {
    return getShopifyCountry() !== 'it';
  }

  function isItalianLocale() {
    return getShopifyLocale() === 'it';
  }

  function isNonEnglishLocale() {
    return getShopifyLocale() !== 'en';
  }

  function shouldGroupPrices() {
    return PRICE_GROUPING_COUNTRIES.includes(getShopifyCountry());
  }

  // ─── URL LOCALIZATION ───────────────────────────────────────────────────────
  function getLocaleSlug() {
    const italian = isItalianLocale();
    const localize = needsLocalization();

    if (italian && !localize) return '';
    if (!italian && !localize) return '/en';
    return `/${getShopifyLocale()}-${getShopifyCountry()}`;
  }

  function localizeProductUrl(url) {
    if (!url) return url;
    const slug = getLocaleSlug();

    const bases = [
      'https://pucci-staging.myshopify.com',
      'https://www.pucci.com',
    ];

    for (const base of bases) {
      if (!url.startsWith(base)) continue;
      const path = url.slice(base.length);
      const localeRegex = /^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/;
      const newPath = localeRegex.test(path) ? path.replace(localeRegex, slug) : slug + path;
      return base + newPath;
    }
    return url;
  }

  // ─── XSE ATTRIBUTION PARAMS ─────────────────────────────────────────────────
  // Propaga i parametri XSE sui link prodotto generati dalle superfici XGEN
  // (search, recommendations) per l'attribuzione GA4. Formato atteso:
  //   ?xse_prod_code=XXXXXX&xse=[deployment_id]
  function appendXseParams(url, prodCode, deploymentId) {
    if (!url || url === '#' || !prodCode || !deploymentId) return url;
    if (/[?&]xse=/.test(url)) return url; // gia presente, no doppione
    const [base, hash = ''] = url.split('#');
    const sep = base.includes('?') ? '&' : '?';
    const params = `xse_prod_code=${encodeURIComponent(prodCode)}&xse=${encodeURIComponent(deploymentId)}`;
    return `${base}${sep}${params}${hash ? '#' + hash : ''}`;
  }

  // ─── PRICE FORMATTING ──────────────────────────────────────────────────────
  function formatPrice(price) {
    try {
      return Intl.NumberFormat(`en-${getShopifyCountry()}`, {
        style: 'currency',
        currency: getShopifyCurrency(),
        maximumFractionDigits: 0,
        useGrouping: shouldGroupPrices(),
      }).format(price);
    } catch (error) {
      console.error('xgen-helpers: Error formatting price:', error.toString());
      return price;
    }
  }

  // ─── FACET VALUE TRANSLATION ────────────────────────────────────────────────
  function translateFacetValue(facetKey, value) {
    if (!value) return value;
    const lang = getShopifyLocale();
    const type = FACET_KEY_TO_TYPE[facetKey];
    if (!type) return value;
    const map = (FACET_TRANSLATION_MAP[lang] || FACET_TRANSLATION_MAP['en'])[type];
    if (!map) return value;
    return map[value.toLowerCase()] || map[value] || value;
  }

  // ─── PRE-RENDER PRODUCT ENRICHMENT ──────────────────────────────────────────
  // Adattato da window.xgenLocalizePredictions: stessa logica, aggiorna l'array
  // invece del DOM così buildProductsHtml riceve i dati già completi.
  async function enrichProductsWithShopifyData(products) {
    const needsLoc = needsLocalization();
    const isItLocale = isItalianLocale();
    const slug = getLocaleSlug();
    // English-in-Italy has slug='/en' but needsLoc=false and isItLocale=false
    const shouldFetch = needsLoc || isItLocale || !!slug;

    // 1. URL localization
    if (shouldFetch) {
      for (const product of products) {
        product.link = localizeProductUrl(product.link);
        product.product_url = localizeProductUrl(product.product_url);
        if (!product.link) product.link = product.product_url;
      }
    }

    // 2. Prezzi da xgen API (base, sovrascritta sotto se fetch Shopify va a buon fine)
    for (const product of products) {
      product.localized_price = formatPrice(product.price);
      product.sale_class = '';
      product.percent_off = '';
      if (product.sale_price !== 'None' && product.sale_price != null) {
        product.localized_compare_price = formatPrice(product.sale_price);
        product.percent_off = Math.trunc(((product.sale_price - product.price) / product.sale_price) * 100);
        product.sale_class = 'xse_sale';
      } else {
        product.localized_compare_price = product.localized_price;
      }
    }

    // 3. Se non serve fetch Shopify, termina qui
    if (!shouldFetch) return;

    // 4. Fetch .json per ogni prodotto (stesso pattern di localize originale)
    const promises = products.map(product =>
      fetch(`${product.link}.json`)
        .then(res => res.json())
        .then(data => ({ [product.prod_code]: data.product }))
        .catch(() => ({}))
    );

    const results = await Promise.all(promises);
    const fetched = Object.assign({}, ...results);
    window.xgenProductsData = Object.assign(window.xgenProductsData ?? {}, fetched);

    // 5. Aggiorna array con dati Shopify (adattato da localizeRecs: DOM → array)
    for (const product of products) {
      const productData = fetched[product.prod_code];
      if (!productData) continue;

      // ID Shopify numerico reale (per wishlist Swym). Su mercati senza fetch
      // si ripiega su prod_code (che corrisponde al product.id Shopify).
      if (productData.id) {
        product.shopify_id = productData.id;
      }

      if (productData.title) {
        product.prod_name = productData.title;
      }

      if (productData.images?.length > 0) {
        product.images = productData.images.map(img => img.src || img);
      }

      if (productData.tags) {
        product.tags = productData.tags;
      }

      const variant = productData.variants?.[0];
      if (!variant?.price) continue;

      const price = parseFloat(variant.price);
      const compareAt = variant.compare_at_price ? parseFloat(variant.compare_at_price) : null;

      product.localized_price = formatPrice(price);

      if (compareAt && compareAt > price) {
        product.localized_compare_price = formatPrice(compareAt);
        const pct = Math.trunc(((compareAt - price) / compareAt) * 100);
        product.percent_off = Number.isFinite(pct) ? pct : '';
        product.sale_class = 'xse_sale';
      } else {
        product.localized_compare_price = product.localized_price;
        product.sale_class = '';
        product.percent_off = '';
      }
    }
  }

  // ─── PUBLIC API ─────────────────────────────────────────────────────────────
  window.xgenHelpers = {
    getShopifyCountry,
    getShopifyLocale,
    getShopifyCurrency,
    needsLocalization,
    isItalianLocale,
    isNonEnglishLocale,
    getLocaleSlug,
    localizeProductUrl,
    appendXseParams,
    formatPrice,
    translateFacetValue,
    enrichProductsWithShopifyData,
  };
})();